export function scrollToElement (element) {
  let elementPosition = element.getBoundingClientRect()
  let scrollTo = window.pageYOffset - (200 - elementPosition.top)
  if (elementPosition.top < 142) {
    window.scrollTo(0, scrollTo)
  }
}
